/**
 * COUNTDOWN MODULE
 * Manages countdown timers for deal sections
 * Auto-initializes elements with [data-countdown-timer]
 */

class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.endDate = new Date(element.dataset.countdownDate).getTime();
    this.daysEl = element.querySelector('[data-countdown-days]');
    this.hoursEl = element.querySelector('[data-countdown-hours]');
    this.minutesEl = element.querySelector('[data-countdown-minutes]');
    this.secondsEl = element.querySelector('[data-countdown-seconds]');
    this.expiredEl = element.querySelector('[data-countdown-expired]');
    
    if (!this.endDate || isNaN(this.endDate)) {
      console.warn('[v0-countdown] Invalid date format for countdown timer');
      return;
    }

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      this.expire();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.daysEl) {
      this.daysEl.textContent = String(days).padStart(2, '0');
    }
    if (this.hoursEl) {
      this.hoursEl.textContent = String(hours).padStart(2, '0');
    }
    if (this.minutesEl) {
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
    }
    if (this.secondsEl) {
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  expire() {
    clearInterval(this.interval);
    if (this.expiredEl) {
      this.expiredEl.style.display = 'block';
    }
    this.element.style.opacity = '0.6';
  }

  destroy() {
    clearInterval(this.interval);
  }
}

// Auto-initialize all countdown timers on page load
document.addEventListener('DOMContentLoaded', () => {
  const timers = document.querySelectorAll('[data-countdown-timer]');
  timers.forEach(timer => {
    new CountdownTimer(timer);
  });
});

// Support dynamic elements (e.g., from AJAX/Fetch)
document.addEventListener('shop:section:load', (event) => {
  const timers = event.detail.querySelector?.('[data-countdown-timer]') || [];
  [timers].forEach(timer => {
    new CountdownTimer(timer);
  });
});

// Export for manual use
window.CountdownTimer = CountdownTimer;
